export default "https://chowbus-web-static.chowbus.com/_next/static/chunks/sofia_pro_regular-b419ddc750987ebcce33b85d682600cb.otf";